export default __webpack_public_path__ + "static/media/why-learn-bg.2d1beee3.jpg";